import { like_api_like_url } from "@/mk/urls/functions";

export function saveLike(xhr, entity, id, isLiked) {
    return xhr.post(like_api_like_url(entity, id), { isLiked });
}
